import { useStoredAttachmentSrc } from "@ext/agent/components/hooks/useStoredAttachmentSrc";
import { FileAttachmentTile } from "@ext/agent/components/panel/FileAttachmentTile";
import { ImageAttachmentPreview } from "@ext/agent/components/panel/ImageAttachmentPreview";
import type { ChatAttachment } from "@ext/agent/core/attachmentStore";

export const SentImageAttachment = ({ attachment }: { attachment: ChatAttachment }) => {
	const { src, failed } = useStoredAttachmentSrc(attachment);
	if (failed) return <FileAttachmentTile mime={attachment.mime} name={attachment.originalFilename} />;
	return <ImageAttachmentPreview name={attachment.originalFilename} src={src} />;
};
